<template>
    <div class="">
        <h5 class="info-head">服务区域<el-button v-if="!isPreAudit" icon="el-icon-plus" @click="add">新增</el-button></h5>
        <table border strip class="info-table">
            <tr>
                <th>序号</th>
                <th><b>*</b>省</th>
                <th>市</th>
                <th>备注</th>
                <th v-if="!isPreAudit">操作</th>
            </tr>
            <tr v-for="a, i in serviceas">
                <td>{{i+1}}</td>
                <td>{{a.province}}</td>
                <td>{{a.city}}</td>
                <td>{{a.cfremark}}</td>
                <td v-if="!isPreAudit">
                    <a @click.prevent="edit(i)" class="edit-btn">编辑</a>
                    <a @click.prevent="remove(i)" class="delete-btn">删除</a>
                </td>
            </tr>
            <tr v-if="!serviceas.length"><td colspan=5>暂无数据</td></tr>
        </table>
        <div class="splitter"></div>
        <div class="text-center">
            <el-button :disabled="isSubmit" type="primary" @click="submit">提交</el-button>
        </div>
        <el-dialog :title="isNaN(editIndex)?'新增服务区域':'编辑服务区域'" :visible.sync="areaFormVisible">
            <el-form :model="area" label-width="100px" :rules="rules" ref="areaForm" class="supplier-form">
                <el-form-item label="省：" prop="cfprovinceid">
                    <el-select v-model="area.cfprovinceid" @change='selectChange' placeholder="请选择" style="float:left">
                        <el-option
                            v-for="item in provinces"
                            :key="item.fid"
                            :label="item.fnameL2"
                            :value="item.fid">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="市：" prop="cfcityid">
                    <el-select v-model="area.cfcityid" placeholder="请选择" style="float:left">
                        <el-option
                            v-for="item in cities"
                            :key="item.fid"
                            :label="item.fnameL2"
                            :value="item.fid">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注：" prop="cfremark"><el-input type="textarea" v-model="area.cfremark" auto-complete="off"></el-input></el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="areaFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitArea">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script type="text/babel">
    import { mapGetters, mapActions, mapMutations } from 'vuex'
    import { SELECT_PROVINCE,ADD_SERVICE_AREA,EDIT_SERVICE_AREA,REMOVE_SERVICE_AREA } from '@/store/mutation-types'
    import { areaRules } from '@/util/rules'

    export default {
        name: 'supplier-service',
        data () {
            return {
                area:{
                    cfprovinceid:'',
                    cfcityid:'',
                    cfremark:'',//备注
                    province:'',
                    city:''
                },
                rules: areaRules,
                areaFormVisible: false,
                editIndex:void(0),//用于编辑、标记新增
                isPreAudit: false,
                isSubmit:false

            }
        },
        computed:{
            ...mapGetters(['serviceas','provinces','cities'])
        },
        watch:{
            "area.cfprovinceid": function(fid){
                if(fid){
                    this.setPid(fid)
                    this.getCities()
                    this.area.province = this.provinces.find(p=>{return p.fid==fid}).fnameL2
                }
            },
            "area.cfcityid": function(cid){
                if(cid){
                    let item = this.cities.find(c=>{return c.fid==cid})
                    if(item){
                        this.area.city = item.fnameL2
                    }
                }
            }
        },
        methods: {
            ...mapActions(['getServiceas','getProvinces','getCities', 'addOrEditArea','removeArea','submitServiceas']),
            ...mapMutations({
                setPid: SELECT_PROVINCE,addArea:ADD_SERVICE_AREA,editArea:EDIT_SERVICE_AREA,delArea:REMOVE_SERVICE_AREA
            }),
            add(){
                this.editIndex = void(0)
                this.area = {
                    cfprovinceid:'',
                    cfcityid:'',
                    cfremark:'',//备注
                    province:'',
                    city:''
                }
                this.areaFormVisible = true
                this.$nextTick(()=>{
                    this.$refs.areaForm.resetFields()
                })
            },
            edit(i){
                this.editIndex = i
                this.areaFormVisible = true
                this.$nextTick(()=> this.area = Object.assign({}, this.serviceas[i]))
                
            },
            remove(i){
                this.$confirm('此操作将删除该条记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.removeArea(i).then(()=>{
//                        this.delArea(i)
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
            },
            selectChange(){
            	this.area.cfcityid='';
            	this.area.city="";
            },
            submitArea(){
                this.$refs.areaForm.validate((valid) => {
                    if (valid) {
                        let payload = {area:this.area, editIndex:this.editIndex}
//                        let isAdd = isNaN(this.editIndex)
//                        this.addOrEditArea(Object.assign({
//                            success:(res)=>{
//                                if(res.data.result){
//                                    this.area.editIndex = this.editIndex
//                                    this[isAdd?'addArea':'editArea'](payload)
//                                    this.$alert(isAdd?'添加成功！':'修改成功！')
//                                }else{
//                                    this.$alert(res.data.message)
//                                }
//                            },error:(err)=>{
//                                this.$alert(`${isAdd?'添加':'修改'}失败：${err}`)
//                            }
//                        }, payload))
                        this.addOrEditArea(payload)
                        this.areaFormVisible = false
                    } else {
                        console.log('error submit!!')
                    }
                })
            },
            submit(){
            	this.isSubmit=true;
                this.submitServiceas().then((res) => {
                    if(res.data.result){
                        this.$confirm(res.data.message||'操作成功！', '', {
                            confirmButtonText: '确定',
                            showCancelButton: false,
                            showClose: false,
                            type: 'success',
                            center: true
                        }).then(() => {
                        	this.isSubmit=false;
                            window.location.reload()
                        },() => {
                        	this.isSubmit=false;
                            window.location.reload()
                        })
                        window.sessionStorage.setItem(this.$route.name,'saved')
                    }else{
                    	this.isSubmit=false;
                        this.$alert(res.data.message)
                    }
                }, err => {
                	this.isSubmit=false;
                    this.$alert(err)
                })
            }
        },
        created(){
            this.$root.loading = true
            Promise.all([this.getServiceas(), this.getProvinces()])
                .then((r)=>this.$root.loading = false)
                .catch((err)=>this.$root.loading = false)
        },
        mounted(){
            this.isPreAudit = window.sessionStorage.getItem('isPreAudit')==1
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/dsp/supplier/Service.vue